import type { Edge } from "reactflow";
import sortBy from "lodash/sortBy";

import { JourneyNodeType } from "src/types/journeys";
import {
  type JourneyNode,
  isExecutableJourneyNode,
} from "src/pages/journeys/types";

import { getBranchNodes } from "./get-branch-nodes";
import { isSegmentBranchNode } from "./type-guards";
import { centerNodesOnX } from "./layout";

export const updateSegmentPriority = (
  segmentNodeId: string,
  nodes: JourneyNode[],
  edges: Edge[],
) => {
  const nodesCopy = nodes.slice().filter(isExecutableJourneyNode);
  const parentNode = nodesCopy.find((node) => node.id === segmentNodeId);

  if (
    !parentNode ||
    (parentNode.data.config.type !== JourneyNodeType.Segments &&
      parentNode.data.config.type !== JourneyNodeType.Function)
  ) {
    return nodesCopy;
  }

  // Get outgoers
  const branchNodes = getBranchNodes(parentNode.id, nodesCopy, edges).filter(
    isSegmentBranchNode,
  );

  // Order outgoers
  const orderedBranchNodes = sortBy(branchNodes, [
    "data.config.segment_is_catch_all",
    "data.config.segment_priority_rank",
  ]);

  const priorityMap = orderedBranchNodes.reduce((all, node, index) => {
    all[node.id] = index;

    return all;
  }, {});

  // Reposition branch nodes based on priority rank
  const positionMap = centerNodesOnX(orderedBranchNodes, parentNode.position.x);

  // Apply new priority rank
  return nodesCopy.map((node) => {
    if (isSegmentBranchNode(node) && priorityMap[node.id] !== undefined) {
      return {
        ...node,
        position: positionMap.get(node.id) ?? node.position,
        data: {
          ...node.data,
          config: {
            ...node.data.config,
            segment_priority_rank: priorityMap[node.id],
          },
        },
      };
    }

    return node;
  });
};
